import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import SmartText from "../../utils/TextHandler";
import SmartColour from "../../utils/ColourHandler";
import ImageHandler from "../../utils/ImageHandler";
import GalleryModal from "../Templates/GalleryModal";
import GalleryMediaItem from "../Media/GalleryMediaItem";
import Slider from "react-slick";

import { galleryActions } from "../../context/gallery";

const SectionGallery = (props) => {
  const { doc } = props;

  const dispatch = useDispatch();
  const storeCurrentIndex = useSelector((state) => state.gallery.currentIndex);

  const colour = SmartColour(doc.colour);

  const carouselRef = useRef();
  const modalRefMedia = useRef();

  // Ensure carousel is always pointing to correct index
  useEffect(() => {
    carouselRef.current.slickGoTo(storeCurrentIndex);
  }, [storeCurrentIndex]);

  const handleGalleryMediaClick = (selectedIndex) => {
    dispatch(galleryActions.setCurrentIndex(selectedIndex));
    modalRefMedia.current.openModal();
  };

  const galleryImagesMap = doc?.items.map((galleryImage, index) => {
    return (
      <GalleryMediaItem
        key={index}
        data={galleryImage}
        clickHandler={() => handleGalleryMediaClick(index)}
      />
    );
  });

  // Set max index in gallery context
  useEffect(() => {
    dispatch(galleryActions.setMaxIndex(doc?.items?.length - 1));
  }, [doc?.items?.length]);

  return (
    <section
      id={doc.id && doc.id}
      className={`brand-section py-5 py-lg-10 d-flex flex-column justify-content-center align-items-center brand-background-${colour.background} brand-text-${colour.text} brand-background-cover`}
      style={
        doc.background && doc.background.filename
          ? {
              backgroundImage: `url(${ImageHandler(
                doc.background.filename,
                "1920x1080"
              )})`,
            }
          : {}
      }
    >
      <div className="container">
        {doc.title && (
          <div className="row justify-content-start mb-5">
            <div className="col">
              <h1 className="text-center brand-font brand-font-responsive brand-text-dirty">
                {doc.title}
              </h1>
              {doc.body && <SmartText>{doc.body}</SmartText>}
            </div>
          </div>
        )}
      </div>

      <div className="container-fluid pb-3">
        {/* Mobile Gallery */}
        <div className="row mobile-gallery-row row-cols-2 gy-4 d-flex d-lg-none">
          {galleryImagesMap}
        </div>

        {/* Desktop Gallery */}
        <div className="row gallery-row d-none d-lg-flex pb-5">
          <Slider ref={carouselRef}>{galleryImagesMap}</Slider>
        </div>
      </div>

      <GalleryModal
        ref={modalRefMedia}
        modalClassName="brand-gallery-media-modal"
        currentIndex={storeCurrentIndex}
        totalItems={doc?.items?.length}
        galleryItems={doc?.items}
      />
    </section>
  );
};

export default SectionGallery;

SectionGallery.propTypes = {
  doc: PropTypes.object,
};

SectionGallery.defaultProps = {
  doc: null,
};
